import React from "react";
import SUDayView from "../SUDayView";

const BehaviourOverviewDay = ({ insights }) => {
  return <SUDayView insights={insights} noData={false} />;
};

export default BehaviourOverviewDay;
